import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import ConfigProvider from '../../config-provider';
import Balloon from '../../balloon';
import Icon from '../../icon';
import { obj } from '../../util';

const { Tooltip } = Balloon;

class GroupAvatar extends React.Component {
  static propTypes = {
    prefix: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    colorSets: PropTypes.arrayOf(PropTypes.string),
    dataSource: PropTypes.arrayOf(PropTypes.shape({
      img: PropTypes.string,
      text: PropTypes.string.isRequired,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })),
    onClickMore: PropTypes.func,
  }

  static defaultProps = {
    prefix: 'next-',
    dataSource: [],
    colorSets: ['#BC61CF', '#F26666', '#F29A52', '#F4C329', '#CBD057', '#289ED3', '#29B3F0'],
    onClickMore: () => {},
  }

  getBgColor = (text, colorSets) => {
    if (typeof text !== 'string' || colorSets.length === 0 || colorSets.length === 1) {
      return '#289ED3';
    }
    const charCode = text.charCodeAt(0);
    const len = colorSets.length;
    const index = charCode % len;
    return colorSets[index];
  }

  render() {
    const {
      prefix,
      dataSource,
      colorSets,
      style,
      className,
      onClickMore,
      ...others
    } = this.props;
    const needMore = dataSource.length > 4;
    return (
      <div
        style={style}
        className={cls({
          [`${prefix}avatar-group`]: true,
          [className]: !!className,
        })}
        {...obj.pickAttrs(others)}
      >
        {
          dataSource.slice(0, 4).map((d, index) => (
            <Tooltip
              key={d.id}
              trigger={
                d.img ?
                  <img
                    src={d.img}
                    className={cls({
                      [`${prefix}avatar-group-img`]: true,
                      [`${prefix}avatar-group-last`]: index === 3,
                    })}
                  />
                  :
                  <span
                    className={cls({
                      [`${prefix}avatar-group-text`]: true,
                      [`${prefix}avatar-group-last`]: index === 3,
                    })}
                    style={{ background: this.getBgColor(d.text, colorSets) }}
                  >
                    <span className="scale">{d.text.slice(0, 2)}</span>
                  </span>
              }
            >
              {d.text}
            </Tooltip>
          ))
        }
        {
          needMore ? <Icon type="more" size="large" onClick={onClickMore} className={`${prefix}avatar-group-more`} /> : null
        }
      </div>
    );
  }
}

export default ConfigProvider.config(GroupAvatar);
